export default __webpack_public_path__ + "static/media/bin.cad340eb.svg";